/**
 * Created by dryymoon on 09.12.16.
 */

import Module from './star-rating';

export default Module;
